// 科技树
<template>
  <div class="page">
    <!-- 背景视频 -->
    <div class="video-background">
      <!-- <img src="../../assets/kjs.png" style="margin-top:147px"/> -->
      <video class="video-background" id="bgVideo" autoplay muted loop>
        <source src="../../assets/kjs.mp4" type="video/mp4">
        您的浏览器不支持视频标签。
      </video>
    </div>
    <!-- <div class="videoBtn" @click="show=!show"><i class="icon" :class="show?'icon_off':'icon_on'"></i>{{show?'隐藏监控':'显示监控'}}</div> -->
    <div class="action">
      <div class="action_btn" @click="$router.go(-1)">返回</div>
      <div class="action_btn" @click="show=!show">{{show?'隐藏监控':'显示监控'}}</div>
    </div>
    <div class="container">
      <div class="treeBox">
        <div class="list" :class="'list'+(index+1)" v-for="(item,index) in kjs.tree" :key="item.id">
          <div class="info" @click="treeClick(item)">
            <span class="name">{{item.title}}</span>
            <div class="starBox">
              <span class="icon iconOut" v-for="star in 5" :key="'out'+star"></span>
              <div class="inbox">
                <span class="icon iconIn" v-for="star in item.star" :key="'in'+star"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page_left" v-if="show && kjs.video">
        <div class="videoBox" v-for="(item,index) in kjs.video.slice(0, 3)" :key="index">
          <h3 class="title">监控视频</h3>
          <div class="main">
            <video v-if="item.url" :src="item.url" controls class="video">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
      <div class="page_right" v-if="show && kjs.video && kjs.video.length>3">
        <div class="videoBox" v-for="(item,index) in kjs.video.slice(3)" :key="index">
          <h3 class="title">监控视频</h3>
          <div class="main">
            <video v-if="item.url" :src="item.url" controls class="video">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
    <Info v-if="infoShow" :visible.sync="infoShow" :info="info"></Info>
  </div>
</template>

<script>

import axios from 'axios'
import Info from './info.vue'
export default {
  name: 'My3DComponent',
  components: {Info},
  data() {
    return {
      type: '',
      infoShow: false,
      info: {},
      show: false,
      kjs: {}
    };
  },
  created() {
    this.type = this.$route.query.type
    this.getData('modelWl')
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          let jsonData = res.data.data
          this.kjs = jsonData.detail.kjxy.kjs.find(it => it.type === this.type)
        }
      })
    },
    treeClick(val){
      this.infoShow = true
      this.info = val
    }
  },
};
</script>

<style lang="less" scoped>
@import '@/styles/subpage';
@import '@/styles/tech';
.video{
  width: 100%;
  height: 100%;
}
</style>